import React, { useState } from 'react';
import styles from './ObjSameThemeIcon.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconProps {
    record: any;
    index: number;
    handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const ObjSameThemeIcon: React.FC<RecordIconProps> = ({ record, index, handleLinkClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    // Ophalen van de juiste velden
    const objectNumber = record?.data?.record?.objectnumber ?? "";
    const titlesort = record?.data?.record?.titlesort ?? "";

    // ✅ Gebruik `getImages()` om de correcte afbeelding te krijgen
    let imageUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}/nondisponible.cci&width=75&height=75`; // Standaard afbeelding
    const allImages = getImages(record);
    if ((allImages as any)["list"]?.length > 0) {
        imageUrl = (allImages as any)["list"][0]?.url;
    }

    return (
        <div 
            className={styles.ObjSameThemeIcon}
            key={index}
            onClick={(event) => handleLinkClick(event, index)}
            onMouseDown={(e) => e.preventDefault()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={styles.iconViewRecord}>
                <ImageWithFallback
                    src={imageUrl}
                    alt={objectNumber}
                    height={75}
                    max-witdh={75}
                    placeholder={`${process.env.REACT_APP_IMAGE_BASE_URL}/nondisponible.cci&width=75&height=75`}
                />
<div >{titlesort}</div>
                {false && isHovered && (
                    <div className={styles.hoverOverlay}>
                        <div className={styles.row}>{objectNumber}</div>
                        <div className={styles.row}>{titlesort}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ObjSameThemeIcon;
